import {createFileRoute} from '@tanstack/react-router';
import {AuthAppPage} from '@/features/auth';

export const Route = createFileRoute('/_auth/auth/app')({
  component: () => <AuthAppPage />,
});
